import { SearchOutlined } from '@ant-design/icons';
import { Button, Col, Input, Row, Select, Spin } from 'antd';
import React, { useState } from 'react';
import { useMediaQuery } from 'react-responsive';

const { Option } = Select;

const SearchRaiseFilters = ({ filtersList, onSearch, onCancel, loading }) => {
    const [filters, setFilters] = useState({});
    const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

    const handleFilterChange = (key, value) => {
        setFilters(prev => ({
            ...prev,
            [key]: value,
        }));
    };

    const handleSearch = () => {
        onSearch(filters);
    };

    const handleReset = () => {
        setFilters({});
        onCancel();
    };

    return (
        <div style={{ width: "100%", marginBottom: "20px" }}>
            <div style={{ background: "#eceff1", padding: "20px", borderRadius: "8px" }}>
                {loading ? (
                    <Spin />
                ) : (
                    <>
                        <Row gutter={[16, 16]}>
                            {filtersList.includes("ticket_id") && (
                                <Col xs={24} sm={12} md={6}>
                                    <Input
                                        placeholder="Filter by Ticket ID"
                                        value={filters.ticket_id || ""}
                                        onPressEnter={handleSearch}
                                        onChange={(e) => handleFilterChange("ticket_id", e.target.value)}
                                        style={{ width: "100%" }}
                                    />
                                </Col>
                            )}

                            {filtersList.includes("ticket_status") && (
                                <Col xs={24} sm={12} md={6}>
                                    <Select
                                        placeholder="Filter by Status"
                                        value={filters.ticket_status}
                                        onChange={(value) => handleFilterChange("ticket_status", value)}
                                        style={{ width: "100%", textAlign: "left" }}
                                        onKeyDown={(e) => { if (e.key === "Enter") handleSearch(); }}
                                    >
                                        <Option value="OPEN">Open</Option>
                                        <Option value="IN_PROGRESS">In Progress</Option>
                                        <Option value="CLOSED">Closed</Option>
                                    </Select>
                                </Col>
                            )}
                        </Row>

                        <Row style={{ marginTop: 16 }}>
                            <Col xs={24} style={{ textAlign: isMobile ? "center" : "right" }}>
                                <Button
                                    type="primary"
                                    icon={<SearchOutlined />}
                                    onClick={handleSearch}
                                    style={{
                                        background: "#040724",
                                        marginRight: 8,
                                        width: isMobile ? "80vw" : 140,
                                    }}
                                >
                                    Search
                                </Button>
                                <Button
                                    type="default"
                                    onClick={handleReset}
                                    style={{ width: isMobile ? "80vw" : 140 }}
                                >
                                    Reset
                                </Button>
                            </Col>
                        </Row>
                    </>
                )}
            </div>
        </div>
    );

};

export default SearchRaiseFilters;
